var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.998,
    height: 76.669,
    viewBox: "0 0 85.998 76.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11550",
    "data-name": "Groupe 11550",
    transform: "translate(-17212.003 -3689.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1255",
    "data-name": "Trac\\xE9 1255",
    d: "M427.975,336.477h-6.161c-.982,0-1.814.167-1.814-1.84v-46.3c0-9.949,5.518-4.62,5.518-13.065V262.692c0-2.342.3-2.425.945-2.425h3.024c.643,0,.945.084.945,2.425v12.583c0,8.444,5.518,3.115,5.518,13.065v46.3c0,2.007-.832,1.84-1.814,1.84Z",
    transform: "translate(16826.992 3429.591)",
    fill: "#609b5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1256",
    "data-name": "Trac\\xE9 1256",
    d: "M248.429,230.046h4.73v9.52H224.785v-9.52h4.727V234.8h4.73v-4.759H243.7V234.8h4.73Zm0-4.761h4.73v-4.761h-4.73Zm0-14.281H234.242v4.761h18.917V201.484h-4.73Zm4.73-42.843v28.562H224.785V168.161Zm-4.73,4.761H229.512v19.04h18.917Zm-4.73,52.363v-4.761H224.785v4.761Zm-14.187-19.042H243.7v-4.759H224.785v14.281h4.727ZM195.535,211v28.562H167.161V211Zm-4.73,4.761H171.888V234.8h18.917Zm-14.187-14.281v4.759h18.917v-4.759Zm18.917-33.323v28.562H167.161V168.161Zm-4.73,4.761H171.888v19.04h18.917Zm-14.187,4.759V187.2h9.457v-9.522Zm-4.73,23.8h-4.727v4.759h4.727Z",
    transform: "translate(17044.842 3526.961)",
    fill: "#609b5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanVert);
export default __webpack_public_path__ + "static/media/scan-vert.925707ea.svg";
export { ForwardRef as ReactComponent };